import React, { useEffect, useState } from 'react'
import { Link as RouterLink, useParams } from 'react-router-dom'
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Link,
  TextField,
  CircularProgress,
  Checkbox,
  Button,
} from '@material-ui/core'
import { Page } from 'components'
import { Logo } from 'components/Logo'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import useRouter from 'utils/useRouter'
import { useFormState } from 'hooks/useFormState'
import { useSetorService } from 'hooks/useSetorService'
import { useSessionService } from 'hooks/useSessionService'
import useStyles from './styles'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const schema = {
  setores: {
    presence: { allowEmpty: false, message: '^Insira os setores vinculados' },
  },
  senha: {
    presence: { allowEmpty: false, message: '^Senha é obrigatório' },
    length: {
      minimum: 8,
      message: '^No mínimo 8 caracteres',
    },
  },
  senhaVerificar: {
    presence: {
      allowEmpty: false,
      message: '^Repetir senha é obrigatório',
    },
    equality: {
      attribute: 'senha',
      message: '^As senhas devem ser iguais',
    },
  },
}

export const ValidarUsuario = () => {
  const classes = useStyles()
  const router = useRouter()
  const { token, idUsuario } = useParams()
  const dadosForm = useFormState(schema, { setores: [] })
  const setorService = useSetorService()
  const sessionService = useSessionService()
  const [setores, setSetores] = useState([])
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [processandoValidacao, setProcessandoValidacao] = useState(false)

  useEffect(() => {
    const fetchSetores = async () => {
      const result = await setorService.listarSetoresAutocadastroAsync(token, setProcessandoSetores)
      setSetores(result)
    }

    fetchSetores()
   
  }, [])

  const handleConfirmar = async () => {
    await sessionService.validarUsuario(
      idUsuario,
      token,
      dadosForm.formState.values,
      setProcessandoValidacao
    )
    router.history.push('/auth/login')
  }

  return (
    <Page className={classes.root} title="Validar usuário - SIGEP">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          {processandoSetores ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <div>
              <div className={classes.profile}>
                <Logo />
                <Typography gutterBottom variant="h3">
                  Preencher dados pendentes
                </Typography>
              </div>
              <div className={classes.fields}>
                <AutocompleteNative
                  name="setores"
                  fullWidth
                  multiple
                  noOptionsText="Sem informações"
                  options={setores}
                  value={dadosForm.formState.values.setores}
                  onChange={(event, newValue) => {
                    dadosForm.handleChangeNewValueByNameProperty(event, newValue, 'setores')
                  }}
                  getOptionSelected={(option, value) => option.id === value || option === value}
                  getOptionLabel={(option) =>
                    `${option.nome} / ${option.divisao.sigla} / ${option.divisao.regional.sigla}`
                  }
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{
                          marginRight: 8,
                        }}
                        checked={selected}
                      />
                      {`${option.nome} / ${option.divisao.sigla} / ${option.divisao.regional.sigla}`}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" label="Setores vinculados" required />
                  )}
                />
              </div>
              <div className={classes.fields}>
                <TextField
                  error={dadosForm.hasError('senha')}
                  fullWidth
                  helperText={
                    dadosForm.hasError('senha') ? dadosForm.formState.errors.senha[0] : null
                  }
                  label="Senha"
                  name="senha"
                  onChange={dadosForm.handleChange}
                  type="password"
                  value={dadosForm.formState.values.senha || ''}
                  variant="outlined"
                  required
                />

                <TextField
                  error={dadosForm.hasError('senhaVerificar')}
                  fullWidth
                  helperText={
                    dadosForm.hasError('senhaVerificar')
                      ? dadosForm.formState.errors.senhaVerificar[0]
                      : null
                  }
                  label="Repetir senha"
                  name="senhaVerificar"
                  onChange={dadosForm.handleChange}
                  type="password"
                  value={dadosForm.formState.values.senhaVerificar || ''}
                  variant="outlined"
                  required
                />
              </div>
              <Button
                className={classes.submitButton}
                color="secondary"
                disabled={!dadosForm.formState.isValid || processandoValidacao}
                size="large"
                variant="contained"
                onClick={handleConfirmar}
              >
                Confirmar
              </Button>
              <Divider className={classes.divider} />
              <Link
                align="center"
                color="secondary"
                component={RouterLink}
                to="/auth/login"
                underline="always"
                variant="subtitle2"
              >
                Voltar a tela de login
              </Link>
            </div>
          )}
        </CardContent>
      </Card>
    </Page>
  )
}
